import moment from 'moment'
import helpers from "@/mixins/helpers";

export default {
  mixins: [ helpers ],
  methods: {
    _paymentStatus(status) {
      const display = {
        paid: { text: "Paid", color: "success", icon: 'paid', outlined: false},
        invoiced: { text: "Invoiced", color: "success", icon: 'paid', outlined: false},
        pending: { text: "Pending", color: "warning", icon: 'paid', outlined: true},
        refunded: { text: "Refunded", color: "warning", icon: 'paid', outlined: false},
      }
      return display[status] || { color: "", text: "", }
    },
    _appointmentStatus(status) {
      const display = {
        confirmed: { text: "Confirmed", color: "success", icon: 'event'},
        canceled: { text: "Cancelled", color: "error", icon: 'event'},
        complete: { text: "Complete", color: undefined, icon: 'event'},
      }
      return display[status] || { color: "", text: "", }
    },
    _mutateAppointments (appointments) {
      return appointments.map((a) => {
        const color =
          a.status === "canceled"
            ? "grey lighten-1"
            : this._emailToColor(a.client.email);
        return {
          ...a,
          color,
          client: {
            ...a.client,
            name: `${a.client.firstName} ${a.client.lastName}`,
            initials: this._initials([a.client.firstName, a.client.lastName]),
            color: this._emailToColor(a.client.email)
          },
          name: `${a.client.firstName} ${a.client.lastName} - ${a.serviceName || ''}`,
          start: moment(a.start).format("YYYY-MM-DD HH:mm:ss"),
          end: moment(a.end).format("YYYY-MM-DD HH:mm:ss"),
          timed: true,
        };
      });
    }
  }
}
